module.exports = __webpack_public_path__ + "img/vertical_3_4_7016.44e3bedc.png";